module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Streaming Settings":"Streaming Settings","Audio":"Audio","Video":"Video","Beauty Filter":"Beauty Filter","Others":"Others"},"zh":{"Streaming Settings":"快速开播","Audio":"音频设置","Video":"视频设置","Beauty Filter":"美颜设置","Others":"其他设置"}}')
  delete Component.options._Ctor
}
